import PropTypes from "prop-types";

import contactProps from "src/shared/utilities/graphql/contactProps";

export default {
  contact: PropTypes.shape(contactProps),
  id: PropTypes.string,
  recent_deals_count: PropTypes.number,
  rentals_in_area_count: PropTypes.number,
  sales_in_area_count: PropTypes.number
};
